export const allowedDomains = ['app', 'jigsaw-research', 'wwf', 'tlacuache-blue', 'rysense', 'natwest', 'sage', 'sage-earth', 'sgn', 'intuit', 'ordnance-survey'];

const getThemeFromUrl = () => {
    if(!process.browser){
       return 'app';
    }
    const loc = window.location;

    const parts = loc.pathname.slice(1).split('/');
    const theme = parts[0];
    const isAProperTheme = allowedDomains.includes(theme);
    return isAProperTheme ? theme : 'app';
};

export default getThemeFromUrl;
